import Download from "src/components/legals/Download";
import A from "src/components/A";

const LINKS = [
  {
    label: "Warranty US/CANADA",
    href: `/docs/legals/bHaptics-Warranty-US-CANADA.pdf`,
  },
  {
    label: "Warranty EU",
    href: `/docs/legals/bHaptics-Warranty-GLOBAL.pdf`,
  },
  {
    label: "Warranty GLOBAL",
    href: `/docs/legals/bHaptics-Warranty-GLOBAL.pdf`,
  },
  {
    label: "Warranty KOREA",
    href: `/docs/legals/bHaptics-Warranty-KOREA.pdf`,
  },
];

const Warranty = () => {
  return (
    <div className={"flex flex-col pt-10"}>
      {LINKS.map((option, index) => {
        return (
          <div key={index} className="flex flex-col gap-y-12">
            <A key={index} className={"mb-5 max-w-[270px]"} href={option.href}>
              <Download label={option.label} />
            </A>
          </div>
        );
      })}
    </div>
  );
};

export default Warranty;
